import type { ReactNode } from "react";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg width="33px" height="34px" viewBox="0 0 33 34" version="1.1">
        <title>more</title>
        <g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
            <circle cx="6" cy="17" r="2.5" />
            <circle cx="16.5" cy="17" r="2.5" />
            <circle cx="27" cy="17" r="2.5" />
        </g>
    </svg>
);

/**
 * Toolbar button for the more actions menu with a horizontal 3-dot icon.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered more button.
 */
const More = (props: React.ComponentProps<typeof Button>) => (
    <Button {...props} renderIcon={renderIcon} />
);

export default More;
